module.exports = __webpack_public_path__ + "img/m_footer.b4ab5a15.png";